import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http";
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { User, Register, Login, Office, Search } from './user.model';
import { Adata } from './adata.model';

@Injectable()
export class UserService {
 //readonly rootUrl = 'http://localhost:14000';
readonly rootUrl = 'http://unicoretestapi.esdinfra.com';
// readonly rootUrl = 'http://192.168.1.45:8081';

 // readonly rootUrl = 'http://182.75.165.138:85';

  httpOptions: any;
  formdata:Adata;
  list:Adata[];

  constructor(private http: HttpClient) {
    let accesstoken = localStorage.getItem('accessToken');
    if (accesstoken != null && accesstoken != '' && typeof (accesstoken) != undefined) {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + accesstoken,
          'No-Auth': 'True'
        })
      };
    }
  }

  getAllowedPages() {
    let accesstoken = localStorage.getItem('accessToken');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + accesstoken
      })
    };
    return this.http.get(this.rootUrl + '/api/AllowedPages', this.httpOptions);
  }

  getAllRoles(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }

  getAllUsers(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Users/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }
  getAllClaimsForTheRole(roleId: string) {
    return this.http.get(this.rootUrl + '/api/Claims/' + roleId, this.httpOptions);
  }
  getRoleForTheId(roleId: string) {
    return this.http.get(this.rootUrl + '/api/Roles/' + roleId, this.httpOptions);
  }

  getUserForTheId(Id: string) {
    return this.http.get(this.rootUrl + '/api/Users/' + Id, this.httpOptions);
  }
  
  getOfficeForTheId(OfficeId: string) {
       return this.http.get(this.rootUrl + '/api/Offices/' + OfficeId, this.httpOptions);
  }

  getAllClaims(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }

  GetAllRoleNames() {
    return this.http.get(this.rootUrl + '/api/Roles/GetAllOffices/', this.httpOptions);
  }

  getAllDistrictName() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Users/GetAllDistrict', this.httpOptions);
  }

  // getRolesforSelectedOffice(officeId) {
  //   return this.http.get(this.rootUrl + '/api/Roles/getRolesforSelectedOffice/' + officeId, this.httpOptions);
  // }
  getRolesforSelectedOffice() {

    return this.http.get(this.rootUrl + '/api/Roles/getRolesforSelectedOffice', this.httpOptions);
  }

  GetAllOffices(comp_id,itemsPerPage:number,pageNo:number) {
    return this.http.get(this.rootUrl + '/api/Offices/GetAll/'+comp_id+"/" +itemsPerPage+"/"+pageNo, this.httpOptions);
  }

  registerUser(register: Register) {
  
    return this.http.post(this.rootUrl + '/api/Account/Register', register, this.httpOptions);
  }

  registerCustomer(register: Register) {
  
    return this.http.post(this.rootUrl + '/api/CustomerAccount/Register', register, this.httpOptions);
  }
  

  createRole(user: User) {
    return this.http.post(this.rootUrl + '/api/Roles/Create', user, this.httpOptions);
  }

  updateRole(user: User,roleId:string) {
    return this.http.put(this.rootUrl + '/api/Roles/Update/'+roleId, user, this.httpOptions);
  }

  searchRoles(searchCriteria:any,searchText:any,itemsPerPage:number,pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  }  

  searchUsers(searchCriteria:any,searchText:any,itemsPerPage:number,pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Users/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  }  

  searchOffices(searchCriteria:any,searchText:any, itemsPerPage:number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Offices/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  }  
  updateOffice(office: Office,OfficeId:string) {
       return this.http.put(this.rootUrl + '/api/Offices/Update/'+OfficeId, office, this.httpOptions);
  }

  saveClaims(claimsList, roleId) {
    return this.http.put(this.rootUrl + '/api/Claims/' + roleId + '/assignClaims', claimsList, this.httpOptions);
  }

  CreateOffice(office: Office) {
    return this.http.post(this.rootUrl + '/api/Offices/Create', office, this.httpOptions);
  }

  changePassword(userDetails:any){
    return this.http.post(this.rootUrl + '/api/Account/ChangePassword', userDetails, this.httpOptions);
  }
  
  changePasswordForTheId(userDetails:any){
    return this.http.put(this.rootUrl + '/api/Account/Update', userDetails, this.httpOptions);
  }

  deleteRole(id: string){
    return this.http.put(this.rootUrl + '/api/Roles/Delete/'+id, this.httpOptions);
  }

  activateInactivateUser(id: string){
    return this.http.put(this.rootUrl + '/api/Users/ActivateInactivate/'+id, null, this.httpOptions);
  }
  
  activateInactivateRoles(id: string){
    return this.http.put(this.rootUrl + '/api/Roles/ActivateInactivate/'+id, null, this.httpOptions);
  }

  activateInactivateOffices(id: string){
    return this.http.put(this.rootUrl + '/api/Offices/ActivateInactivate/'+id, null, this.httpOptions);
  }


//offices
GetAllDistrictNames() {
  return this.http.get(this.rootUrl + '/api/Offices/GetDistrict/', this.httpOptions);
}

GetAllOfficelevels() {
  return this.http.get(this.rootUrl + '/api/Offices/GetOfficelevel/', this.httpOptions);
}

// ComplaintType
  GetComplaintTypeDetails(itemsPerPage:any,pageNo:any) {
    return this.http.get(this.rootUrl + '/api/ComplaintTypeDetails/GetAllComplaintType/'+itemsPerPage+"/"+pageNo, this.httpOptions);
  
  }
  DeleteComplaintType(cmplnt_id) {
    return this.http.delete(this.rootUrl + '/api/ComplaintTypeDetails/DeleteComplaintType/' + cmplnt_id, this.httpOptions);
  }
  SearchComplaintType(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/ComplaintTypeDetails/GetAllComplaintTypeBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
  }
  GetComplaintTypeById(cmplnt_id) {
    return this.http.get(this.rootUrl + '/api/ComplaintTypeDetails/GetByIdComplaintType/' +cmplnt_id , this.httpOptions);
  }
  PostComplaintType(udm) {
    return this.http.post(this.rootUrl + '/api/ComplaintTypeDetails/CreateComplaintType', udm, this.httpOptions);
  }
  
  UpdateComplaintType(udm,cmplnt_id) {
    return this.http.put(this.rootUrl + '/api/ComplaintTypeDetails/UpdateComplaintType/'+cmplnt_id, udm, this.httpOptions);
  }
  
//Enactments


GetEnactmentsDetails(itemsPerPage:any,pageNo:any) {
  return this.http.get(this.rootUrl + '/api/EnactmentsDetails/GetAllEnactments/'+itemsPerPage+"/"+pageNo, this.httpOptions);

}
DeleteEnactments(Enactment_id) {
  return this.http.delete(this.rootUrl + '/api/EnactmentsDetails/DeleteEnactments/' + Enactment_id, this.httpOptions);
}
SearchEnactments(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/EnactmentsDetails/GetAllEnactmentsBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}
GetEnactmentById(Enactment_id) {
  return this.http.get(this.rootUrl + '/api/EnactmentsDetails/GetByIdEnactments/' +Enactment_id , this.httpOptions);
}
PostEnactments(udm) {
  return this.http.post(this.rootUrl + '/api/EnactmentsDetails/CreateEnactments', udm, this.httpOptions);
}
UpdateEnactments(udm,Enactment_id) {
  return this.http.put(this.rootUrl + '/api/EnactmentsDetails/UpdateEnactments/'+Enactment_id, udm, this.httpOptions);
}

//jurisdiction

GetJurisdictionDetails(itemsPerPage:any,pageNo:any) {
  return this.http.get(this.rootUrl + '/api/JurisdictionDetails/GetAllJurisdiction/'+itemsPerPage+"/"+pageNo, this.httpOptions);

}
DeleteJurisdiction(Jurt_id) {
  return this.http.delete(this.rootUrl + '/api/JurisdictionDetails/DeleteJurisdiction/' + Jurt_id, this.httpOptions);
}
SearchJurisdiction(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/JurisdictionDetails/GetAllJurisdictionBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}
GetJurisdictionById(Jurt_id) {
  return this.http.get(this.rootUrl + '/api/JurisdictionDetails/GetByIdJurisdiction/' +Jurt_id , this.httpOptions);
}
PostJurisdiction(udm) {
  return this.http.post(this.rootUrl + '/api/JurisdictionDetails/CreateJurisdiction', udm, this.httpOptions);
}
UpdateJurisdiction(udm,Jurt_id) {
  return this.http.put(this.rootUrl + '/api/JurisdictionDetails/UpdateJurisdiction/'+Jurt_id, udm, this.httpOptions);
}


//office

GetMOfficeDetails(itemsPerPage:any,pageNo:any) {
  return this.http.get(this.rootUrl + '/api/MOfficeDetails/GetAllMOffice/'+itemsPerPage+"/"+pageNo, this.httpOptions);

}
DeleteMOffice(Office_id) {
  return this.http.delete(this.rootUrl + '/api/MOfficeDetails/DeleteMOffice/' + Office_id, this.httpOptions);
}
SearchMOffice(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/MOfficeDetails/GetAllMOfficeBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}
GetMOfficeById(Office_id) {
  return this.http.get(this.rootUrl + '/api/MOfficeDetails/GetByIdMOffice/' +Office_id , this.httpOptions);
}
PostMOffice(udm) {
  return this.http.post(this.rootUrl + '/api/MOfficeDetails/CreateMOffice', udm, this.httpOptions);
}
UpdateMOffice(udm,Office_id) {
  return this.http.put(this.rootUrl + '/api/MOfficeDetails/UpdateMOffice/'+Office_id, udm, this.httpOptions);
}


//DEpartment


GetDepartmentDetails(itemsPerPage:any,pageNo:any) {
  return this.http.get(this.rootUrl + '/api/DepartmentDetails/GetAllDepartment/'+itemsPerPage+"/"+pageNo, this.httpOptions);

}
DeleteDepartment(Jurt_id) {
  return this.http.delete(this.rootUrl + '/api/DepartmentDetails/DeleteDepartment/' + Jurt_id, this.httpOptions);
}

SearchDepartment(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/DepartmentDetails/GetAllDepartmentBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}

GetDepartmentById(Jurt_id) {
  return this.http.get(this.rootUrl + '/api/DepartmentDetails/GetByIdDepartment/' +Jurt_id , this.httpOptions);
}
PostDepartment(udm) {
  return this.http.post(this.rootUrl + '/api/DepartmentDetails/CreateDepartment', udm, this.httpOptions);
}

UpdateDepartment(udm,Jurt_id) {
  return this.http.put(this.rootUrl + '/api/DepartmentDetails/UpdateDepartment/'+Jurt_id, udm, this.httpOptions);
}




//
  userAuthentication(user: Login) {
    var data = "username=" + user.UserName + "&password=" + user.Password + "&grant_type=password";
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' })
    }
    return this.http.post(this.rootUrl + '/token', data, httpOptions);
  }
  ////Complaint GET
  
  GetComplaintDetails(itemsPerPage:any,pageNo:any) {
    return this.http.get(this.rootUrl + '/api/ComplaintDetails/GetAllComplaint/'+itemsPerPage+"/"+pageNo, this.httpOptions);
  
  }
//Search omplaint
SearchComplaint(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/ComplaintDetails/GetAllComplaintBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}

// get compliant tyope details in complaint
GetAllComplaintType() {
  return this.http.get(this.rootUrl + '/api/ComplaintDetails/GetComplaintType', this.httpOptions);
}
PostComplaint(udm) {
  return this.http.post(this.rootUrl + '/api/ComplaintDetails/CreateComplaint', udm, this.httpOptions);
}
uploadImage(data) {
  return this.http.post(this.rootUrl + '/api/ComplaintDetails/image', data);
}

getAllCustomerDetails(itemsPerPage: number, pageNo: number,logbranch) {
  debugger;
  return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllCustomerDetails/' + itemsPerPage + "/" + pageNo+"/"+logbranch, this.httpOptions);
}

getCustomerDetailsById(id){
  return this.http.get(this.rootUrl + '/api/CustomerCreation/GetCustomerDetailsById/' +id , this.httpOptions);
}

GetByIdComplaint(Comp_id) {
  return this.http.get(this.rootUrl + '/api/ComplaintDetails/GetByIdComplaint/' +Comp_id , this.httpOptions);
}
UpdateComplaint(udm,Comp_id) {
  return this.http.put(this.rootUrl + '/api/ComplaintDetails/UpdateComplaint/'+Comp_id, udm, this.httpOptions);
}
DeleteComplaint(Comp_id) {
  return this.http.delete(this.rootUrl + '/api/ComplaintDetails/DeleteComplaint/' + Comp_id, this.httpOptions);
}
//office ddl
GetAllOffice1() {
  return this.http.get(this.rootUrl + '/api/ComplaintDetails/GetOffice', this.httpOptions);
}
uploadImage3(data) {
  return this.http.post(this.rootUrl + '/api/ComplaintDetails/image3', data);
}
//Fir Module

GetFirDetails(itemsPerPage:any,pageNo:any) {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetAllFir/'+itemsPerPage+"/"+pageNo, this.httpOptions);

}
SearchFir(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetAllFirBySearch/' + '/' + "/" + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}

SearchFirdetails(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetAllFirBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}

PostFir(udm) {
  return this.http.post(this.rootUrl + '/api/FirDetails/CreateFir', udm, this.httpOptions);
}



//getting offc ddl

GetAllOffice() {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetOffice', this.httpOptions);
}
//get district ddl

GetAllDistrict() {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetDistrict', this.httpOptions);
}

//get complainttype ddl
 GetAllComplaintT() {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetComplaintType', this.httpOptions);
}


//get state ddl
GetAllState() {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetState', this.httpOptions);
}
//get all enactment ddl 
GetAllEnactment() {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetEnactment', this.httpOptions);
}
GetByIdFir(Fir_id) {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetByIdFir/' +Fir_id , this.httpOptions);
}


UpdateFir(udm,Fir_id) {
  return this.http.put(this.rootUrl + '/api/FirDetails/UpdateFir/'+Fir_id, udm, this.httpOptions);
}
DeleteFir(Fir_id) {
  return this.http.delete(this.rootUrl + '/api/FirDetails/DeleteFir/' + Fir_id, this.httpOptions);
}

//upload
uploadImage1(data) {
  return this.http.post(this.rootUrl + '/api/FirDetails/image1', data);
}
uploadImage2(data) {
  return this.http.post(this.rootUrl + '/api/FirDetails/image1', data);
}

//Proceeding details

GetAllFirPagination(itemsPerPage: number, PageNo: number) {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetAllFir/' + itemsPerPage + '/' + PageNo, this.httpOptions);
}
GetFirProceedingetails(Fir_id) {
  return this.http.get(this.rootUrl + '/api/ProceedingDetails/GetFirDetailsForProceedings/' + Fir_id, this.httpOptions);

}

PostProceeding(udm) {
  return this.http.post(this.rootUrl + '/api/ProceedingDetails/CreateProceedings', udm, this.httpOptions);
}
uploadImage5(data) {
  return this.http.post(this.rootUrl + '/api/ProceedingDetails/image5', data);
}

GetAllProceedingDetails(itemsPerPage:any,pageNo:any,Fir_id) {
  debugger;
  return this.http.get(this.rootUrl + '/api/ProceedingDetails/GetAllProceedings/' +itemsPerPage+"/" +pageNo+"/"+ Fir_id ,this.httpOptions);

}
// GetProceedingOnSearch(Fir_id, NextHearingDate, value) {
//   return this.http.get(this.rootUrl + '/api/ProceedingDetails/GetAllProceedingsOnserach/' + Fir_id + '/' + NextHearingDate + '/' + value, this.httpOptions);

// }
GetProceedingOnSearch(Fir_id: any,searchBy: any, searchValue: any, ItemsPerPage: number, pageno: number) {
  return this.http.get(this.rootUrl + '/api/ProceedingDetails/GetAllProceedingsOnserach/' + Fir_id + "/" + ItemsPerPage + "/" + pageno + "/" + searchBy + "/" + searchValue + "/",this.httpOptions);
}

DeleteProcById(Proc_Id) {
  return this.http.delete(this.rootUrl + '/api/ProceedingDetails/DeleteProceeding/' + Proc_Id, this.httpOptions);
}

calculateAge(dateOfBirth) {

  return this.http.get(this.rootUrl + '/api/ComplaintDetails/calculateAge/' + dateOfBirth, this.httpOptions);
}


//investigation
GetFirInvestigationetails(Fir_id) {
  return this.http.get(this.rootUrl + '/api/InvestigationDetails/GetFirInvestigationetails/' + Fir_id, this.httpOptions);

}

PostInvestigation(udm) {
  return this.http.post(this.rootUrl + '/api/InvestigationDetails/CreateInvestigationDoc', udm, this.httpOptions);
}
GetAllInvestigationDetails(itemsPerPage:any,pageNo:any,Fir_id) {
  debugger;
  return this.http.get(this.rootUrl + '/api/InvestigationDetails/GetAllInvestigation/' +itemsPerPage+"/" +pageNo+"/"+ Fir_id ,this.httpOptions);

}
DeleteInvestigationById(InvDoc_Id) {
  return this.http.delete(this.rootUrl + '/api/InvestigationDetails/DeleteInvestigation/' + InvDoc_Id, this.httpOptions);
}
GetInvestigationOnSearch(Fir_id: any,searchBy: any, searchValue: any, ItemsPerPage: number, pageno: number) {
  return this.http.get(this.rootUrl + '/api/InvestigationDetails/GetAllInvestigationDocOnserach/' + Fir_id + "/" + ItemsPerPage + "/" + pageno + "/" + searchBy + "/" + searchValue + "/",this.httpOptions);
}
uploadImage6(data) {
  return this.http.post(this.rootUrl + '/api/InvestigationDetails/image6', data);
}
GetAllFirPaginations(itemsPerPage: number, PageNo: number) {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetAllFir/' + itemsPerPage + '/' + PageNo, this.httpOptions);
}

UpdateFile(udm, InvDoc_Id :any) {
  return this.http.post(this.rootUrl + '/api/InvestigationDetails/Updatefile' +'/'+InvDoc_Id, udm, this.httpOptions);
}


GetInvestigationById(InvDoc_Id) {
  debugger;
  return this.http.get(this.rootUrl + '/api/InvestigationDetails/GetByIdInvestigation/' +InvDoc_Id , this.httpOptions);
}
GetAllDepartment() {
  return this.http.get(this.rootUrl + '/api/InvestigationDetails/GetDepartment', this.httpOptions);
}
GetDeptDoc(dep_Id) {
  return this.http.get(this.rootUrl + '/api/InvestigationDetails/GetDeptDoc/' + dep_Id, this.httpOptions);

}
//DepartmentDocument

GetAllDepartmentPagination(itemsPerPage: number, PageNo: number) {
  return this.http.get(this.rootUrl + '/api/DepartmentDetails/GetAllDepartment/' + itemsPerPage + '/' + PageNo, this.httpOptions);
}

SearchDepartmentsdetails(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/DepartmentDetails/GetAllDepartmentBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}
GetDepartmentGridDetails(dep_Id) {
  return this.http.get(this.rootUrl + '/api/DepartmentDocumentDetails/GetDepartmentGridDetails/' + dep_Id, this.httpOptions);

}
PostDepartmentDocument(udm) {
  return this.http.post(this.rootUrl + '/api/DepartmentDocumentDetails/CreateDepartmentDocument', udm, this.httpOptions);
}
GetAllDepartmentDocumentDetails(itemsPerPage:any,pageNo:any,dep_Id) {
  debugger;
  return this.http.get(this.rootUrl + '/api/DepartmentDocumentDetails/GetAllDepartmentDocument/' +itemsPerPage+"/" +pageNo+"/"+ dep_Id ,this.httpOptions);

}
GetDepartmentDocumentOnSearch(dep_Id: any,searchBy: any, searchValue: any, ItemsPerPage: number, pageno: number) {
  return this.http.get(this.rootUrl + '/api/DepartmentDocumentDetails/GetAllDepartmentDocumentOnserach/' + dep_Id + "/" + ItemsPerPage + "/" + pageno + "/" + searchBy + "/" + searchValue + "/",this.httpOptions);
}
DeleteDepartmentDocumentById(DeptDoc_Id) {
  return this.http.delete(this.rootUrl + '/api/DepartmentDocumentDetails/DeleteDepartmentDocument/' + DeptDoc_Id, this.httpOptions);
}



//UNIcore
GetAllCustomerIds()
{
  return this.http.get(this.rootUrl+'/api/PigmyCreations/CustTitleDetails', this.httpOptions);
}

GetAllSchemes(branchid)
{
  debugger;
  return this.http.get(this.rootUrl+'/api/PigmyCreations/schemeslist/'+branchid, this.httpOptions);
}
getpigmySchemeType(glsubid:number,branchid:number)
{
  debugger;
  return this.http.get(this.rootUrl+'/api/PigmyCreations/schemestypelist/'+glsubid+"/"+branchid, this.httpOptions);
}

GetAllAgents()
{
  return this.http.get(this.rootUrl+'/api/PigmyCreations/agentslist', this.httpOptions);
}
GetAgentsforaccount(branchid,glsub)
{
  return this.http.get(this.rootUrl+'/api/PigmyCreations/agentslistforaccountcreation/'+branchid+'/'+glsub, this.httpOptions);
}
getsuspsnamt(AgentId)
{
  return this.http.get(this.rootUrl+'/api/PigmyCreations/getsuspenseofangent/'+AgentId, this.httpOptions);
}

GetAllRelations()
{
  return this.http.get(this.rootUrl+'/api/PigmyCreations/getrelations', this.httpOptions);
}

createApplication_Mast(data: any) {

  return this.http.post(this.rootUrl + '/api/PigmyCreations/createApplicationMast', data, this.httpOptions);
}

GetAutogenerationAccontNumber(CustId: any,AgentId : any,glsubId: any,data: any) {
  return this.http.post(this.rootUrl + '/api/PigmyCreations/Accountcreation/'+CustId+
  '/'+AgentId+'/'+glsubId,data,this.httpOptions);
}

// GetAllPigmyCreations()
// {
//   return this.http.get(this.rootUrl+'/api/PigmyCreations/GetPigmycreation');
// }


GetAgentById(ACC_Id : any)
{
  return this.http.get(this.rootUrl+'/api/PigmyCreations/GetPigmycreationById/'+ACC_Id, this.httpOptions);
}

GetAllCustomerIdDetailsforSpeedSearch(CUSTID : any)
{
  return this.http.get(this.rootUrl+'/api/PigmyCreations/GetAllCustomerIdDetailsforSpeedSearch/'+CUSTID, this.httpOptions);
}

postcustomercreate()
   {
    return this.http.post(this.rootUrl+'/api/Customers',this.httpOptions, this.httpOptions);
   }
   
 postArea(formdata:any)
 {

   return this.http.post(this.rootUrl+'/api/Areas/CreateArea',formdata,this.httpOptions);
 }
 gettaluks()
 {
    return this.http.get(this.rootUrl+'/api/areas/GetAlltaluks',this.httpOptions);
   
 }
getdistrict()
{
  return this.http.get(this.rootUrl+'/api/areas/GetallDistrictdetails',this.httpOptions);
}
 
getstate()
{
  return this.http.get(this.rootUrl+'/api/areas/Getallstatedetails',this.httpOptions);
}
getcountry()
{
  return this.http.get(this.rootUrl+'/api/areas/Getallcountrydetails',this.httpOptions);
}

getnextareacode()
{
  return this.http.get(this.rootUrl+'/api/areas/GetLAreaCode',this.httpOptions);
}
//for grid area
getAllAreadetails(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/areas/GetallAreaDetails/' + itemsPerPage + "/" + pageNo, this.httpOptions);
}

GetAreaById(ACODE:number)
{
  debugger;
  return this.http.get(this.rootUrl+'/api/Areas/'+ ACODE , this.httpOptions);
}

deletearea(ACODE:number)
{
  debugger;
  return this.http.get(this.rootUrl+'/api/Areas/Delete/'+ACODE ,this.httpOptions);
}

 refreshList()
 {
   this.http.get(this.rootUrl+'/api/CAREA')
   .toPromise().then(res=>this.list=res as Adata[]);
 }


 searcharea(searchCriteria: any, searchText: any,itemsPerPage: number, pageNo: number)
 {
   debugger;
  return this.http.get(this.rootUrl+'/api/Areas/Search/'+searchCriteria +"/"+searchText+'/'+itemsPerPage+'/'+pageNo, this.httpOptions);
 }

 getbranch()
 {
   return this.http.get(this.rootUrl+'/api/LedgerAccount/BranchSelect',this.httpOptions);
 }

 //bank
 postbank(branchformd: any)
 {
  debugger;
   return this.http.post(this.rootUrl+'/api/BankAccount/Createbank',branchformd,this.httpOptions);
 }

 getbankledger()
 {
   return this.http.get(this.rootUrl+'/api/BankAccount/GetallLedgerAccountDetails',this.httpOptions);
 }

  getallbank(itemsPerPage: number, pageNo: number)
  {
    return this.http.get(this.rootUrl+'/api/BankAccount/GetallBankAccountDetails/'+ itemsPerPage + "/" + pageNo, this.httpOptions)
  }

  getbankbyid(BANKID:number)
  {
    return this.http.get(this.rootUrl+'/api/BankAccount/'+BANKID,this.httpOptions);
  }


  //for pigypartpaymenmt
  gettrans()
  {
    return this.http.get(this.rootUrl+'/api/Pigmy/Getscheme',this.httpOptions);
  }
  getscheme(module:any)
  {
   
    return this.http.get(this.rootUrl+'/api/Pigmy/Scheme/'+module,this.httpOptions);
  }

  // fetchpigmyaxno(acno:string,glsbid:number,brnchid:number)
  // {
  //  debugger;
  //   return this.http.get(this.rootUrl+'/api/Pigmy/GetPigmyDetails/'+acno+'/'+glsbid+'/'+brnchid,this.httpOptions);
  // }

  Pigmypartpay(formpigmypart:any)
  {
    debugger;  
    return this.http.post(this.rootUrl+'/api/Pigmy/PartPayment/',formpigmypart,this.httpOptions);  
  }
  loadstmt(custid)
  {
    debugger;
    return  this.http.get(this.rootUrl+'/api/Pigmy/ldstmt/'+custid,this.httpOptions);  
  }


  getAllACountType()
{

   return this.http.get(this.rootUrl +'/api/PigmyManualCollection/AccountTypeDetails',this.httpOptions);
}


getPigmyBranchList()
{
   return this.http.get(this.rootUrl +'/api/PigmyManualCollection/GetPigmyBranch',this.httpOptions);
}

getAllSchemeType()
{
  
  return this.http.get(this.rootUrl +'/api/PigmyManualCollection/GetPigmyScheme',this.httpOptions);
}

getSubBranch(GRP_ABB:any)
{
  return this.http.get(this.rootUrl+'/api/PigmyManualCollection/GetSubBranchByID/' + GRP_ABB,this.httpOptions)
}

GetallPigmylist(Account_Code:any,SubBranchCode:any,BranchCode:any,SchemeCode:any,Entry_Date:any,Collection_date:any) 
{
  return this.http.get(this.rootUrl + '/api/PigmyManualCollection/GetallPigmyManualCollection/'+ Account_Code + '/'+ SubBranchCode+ '/'+ BranchCode + '/' + SchemeCode +'/'+ Entry_Date + '/'+ Collection_date , this.httpOptions);

}
  // PostPigmyManual(data:any) 
  // {
  //   debugger
  //    //alert("hello")
  //    return this.http.post(this.rootUrl + '/api/PigmyManualCollection/CreatePigmyManual',data, this.httpOptions);
  // }



  GetPigmyDetails(itemsPerPage:any,pageNo:any,branch_id) {

    debugger;
    return this.http.get(this.rootUrl + '/api/PigmyDetails/GetAllPigmy/'+itemsPerPage+"/"+pageNo+"/"+branch_id, this.httpOptions);
  
  }
  
  
  SearchPigmy(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
    debugger;
    return this.http.get(this.rootUrl + '/api/PigmyDetails/Search/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
  }
  //ddl for branch
  GetAllBranch() { 
     return this.http.get(this.rootUrl + '/api/PigmyDetails/GetBranch', this.httpOptions);
   
  }
  //ddl for designation
  GetAllDesignation() { 
    return this.http.get(this.rootUrl + '/api/PigmyDetails/GetDesignation', this.httpOptions);
  
  }
  //ddl for 
  GetAllCust() { 
    return this.http.get(this.rootUrl + '/api/PigmyDetails/GetCust', this.httpOptions);
  
  }
  GetAgentName(CUSTID) { 
    return this.http.get(this.rootUrl + '/api/PigmyDetails/GetAgentName/' +CUSTID , this.httpOptions);
  
  }
  GetAccNo(CUSTID) { 
    return this.http.get(this.rootUrl + '/api/PigmyDetails/GetAccNo/' +CUSTID , this.httpOptions);
  }
  
  PostPigmy(udm) {
    return this.http.post(this.rootUrl + '/api/PigmyDetails/CreatePigmy', udm, this.httpOptions);
  }
  DeletePigmy(AGENT_ID) {
    return this.http.delete(this.rootUrl + '/api/PigmyDetails/DeletePigmy/' + AGENT_ID, this.httpOptions);
  }
  GetPigmyById(AGENT_ID) {
   // console.log((this.rootUrl + '/api/PigmyDetails/GetByIdComplaintType/' +AGENT_ID));
    return this.http.get(this.rootUrl + '/api/PigmyDetails/GetByIdPigmy/' +AGENT_ID , this.httpOptions);
  }
  
  UpdatePigmy(udm,AGENT_ID) {
    return this.http.put(this.rootUrl + '/api/PigmyDetails/UpdatePigmy/'+AGENT_ID, udm, this.httpOptions);
  }
  
  GetCustomerDetails(SearchValue: any, SearchName: any,BRANCH_ID) {
    return this.http.get(this.rootUrl + '/api/PigmyDetails/GetCustomerPigmyDetails/' + SearchValue + "/" + SearchName + "/" +BRANCH_ID, this.httpOptions);
  }
  GetCode() { 
    debugger;
    return this.http.get(this.rootUrl + '/api/PigmyDetails/GetCodePigmy', this.httpOptions);
  
  }
  getadddoc(custid)
  {
    debugger;
    return this.http.get(this.rootUrl + '/api/PigmyDetails/GetCustaddoc/'+custid, this.httpOptions);
  
  }
  getdoc(custid)
  {
    debugger;
    return this.http.get(this.rootUrl + '/api/PigmyDetails/GetCustdoc/'+custid, this.httpOptions);
  
  }




  //customer creation

 getAllBranches() {
  debugger;
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllBranches', this.httpOptions);
}

getMaxCustomerId(BRANCH_ID:any)
{
  debugger;
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetMaxCustomerID/'+ BRANCH_ID, this.httpOptions);
}

getAllAreas() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllAreas', this.httpOptions);
}

getAllTaluks() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllTaluks', this.httpOptions);
}

getAllDistricts() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllDistricts', this.httpOptions);
}

getAllStates() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllStates', this.httpOptions);
}

getAllCaste() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllCaste', this.httpOptions);
}

getAllReligion() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllReligion', this.httpOptions);
}

getAllReservation() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllReservation', this.httpOptions);
}

getAllPriveleges() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllPrivileges', this.httpOptions);
}

getAllCategory() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllCategory', this.httpOptions);
}

getAllOccupation() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllOccupation', this.httpOptions);
}

getAllEducation() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllEducation', this.httpOptions);
}

getAllMartialStatusList() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllMartialStatus', this.httpOptions);
}

getAlldesignationsList() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllDesignations', this.httpOptions);
}

getAlldocumentNamesList() {
 return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllDocumentNames', this.httpOptions);
}

SaveCustomerDetails(udm) {
  debugger;
 return this.http.post(this.rootUrl + '/api/CustomerCreation/SaveCustomerDetails',udm, this.httpOptions);
}

uploadImagecus(data){ 
 debugger;   
 return this.http.post(this.rootUrl+"/api/CustomerCreation/image",data);
}
GetAllAgent() { 
  return this.http.get(this.rootUrl + '/api/AgentDetails/GetAgentDetails', this.httpOptions);

}

GetAllAgent2() { 
  return this.http.get(this.rootUrl + '/api/AgentDetails/GetAgentDetails', this.httpOptions);

}


GetAgentAccDetailsById(AGENT_ID) {  
  return this.http.get(this.rootUrl + '/api/AgentDetails/GetByIdCustomerDetails/' +AGENT_ID , this.httpOptions);
}
UpdateAgent(AGENT_ID,udm) {
  debugger;
  return this.http.put(this.rootUrl + '/api/AgentDetails/UpdateAgent/'+AGENT_ID, udm, this.httpOptions);
}

getbranch1()
{
  return this.http.get(this.rootUrl+'/api/LedgerAccount/BranchSelect',this.httpOptions);
}
getagent()
{
  
  return this.http.get(this.rootUrl+'/api/PigmyImport/AgentSelect' ,this.httpOptions);
}
getPigmyRemiDetails(BranchCode:number,SchemeCode:number,Entry_Date:any)
 {
   
   return this.http.get(this.rootUrl+'/api/PigmyRemittance/GetAllPigmyRem/'+BranchCode+'/'+SchemeCode+'/'+Entry_Date ,this.httpOptions)
 }

 createPigmyRemittance(formd:any)
 {
   debugger;
   return this.http.post(this.rootUrl+'/api/PigmyRemittance/CreatePigmyRemittance',formd,this.httpOptions);
 }
 
 PigmyClosure(formpigmypart:any)
 {
   debugger;
   console.log(formpigmypart);
   return this.http.post(this.rootUrl+'/api/Pigmy/Closure',formpigmypart,this.httpOptions);  
 }
 

 PigmyBranchList()
{
   return this.http.get(this.rootUrl +'/api/PigmyValidation/GetPigmyBranch',this.httpOptions);
}

AllACountType()
{
   return this.http.get(this.rootUrl +'/api/PigmyValidation/AccountTypeDetails',this.httpOptions);
}

GetAllLedgerType()
{
   return this.http.get(this.rootUrl +'/api/PigmyValidation/GetAllLedgerDetails',this.httpOptions);
}

SubBranchList()
{
   return this.http.get(this.rootUrl +'/api/PigmyValidation/GetAllSubLedgerDetails',this.httpOptions);
}


GetallPigmyValidationlist(BranchCode:any,ModualCode:any,L_CODE:any,GLSUB_ID:any,Account_Number:any) 
{
  debugger;
  return this.http.get(this.rootUrl + '/api/PigmyValidation/GetAllPigmyManualCollection/'+ BranchCode + '/'+ ModualCode+ '/'+ L_CODE + '/' + GLSUB_ID + '/' + Account_Number , this.httpOptions);
}
PigAccountList()
{  
   return this.http.get(this.rootUrl +'/api/PigmyValidation/GetAllAccountDetails',this.httpOptions);
}

GetAccountTypeForScheduleReport()
{  
   return this.http.get(this.rootUrl +'/api/ScheduleReports/GetAllAccountType',this.httpOptions);
}

GetAllLedgerName(MODID)
{  
   return this.http.get(this.rootUrl +'/api/ScheduleReports/GetAllLedgerName/'+MODID,this.httpOptions);
}


GetAllBranches()
{  
   return this.http.get(this.rootUrl +'/api/ScheduleReports/GetAllBranches',this.httpOptions);
}

GetAllAgentNames(branchId)
{  
   return this.http.get(this.rootUrl +'/api/ScheduleReports/getAllAgents/'+branchId,this.httpOptions);
}

PostPigmyManual(data:any) 
{
  debugger
   return this.http.post(this.rootUrl + '/api/PigmyManualCollection/CreatePigmyManual',data, this.httpOptions);
}


//

 updateCustomerDetails(udm) {
   debugger;
   return this.http.put(this.rootUrl + '/api/CustomerCreation/UpdateCustomerDetails', udm, this.httpOptions);
 }

 scheduleReport(Form){
  return this.http.post(this.rootUrl + '/api/ScheduleReports/GetShceduleReports',Form, this.httpOptions);
 }


 GetSubLedger(LCode){
  return this.http.post(this.rootUrl + '/api/ScheduleReports/GetSubLedgerCode/'+LCode,null ,this.httpOptions);
 }
 

 GetComputerizeddate(BranchId){
  return this.http.get(this.rootUrl + '/api/ScheduleReports/GetComputerizedDate/'+BranchId, this.httpOptions);
 }
 

 GetCategories(){
  return this.http.get(this.rootUrl + '/api/ScheduleReports/getAllCategories', this.httpOptions);
 }


 GetCaompanies(){
  return this.http.get(this.rootUrl + '/api/ScheduleReports/getCompany', this.httpOptions);
 }
 
 GetAllPigmyCreations(itemsPerPage:any,pageNo:any)
{
  return this.http.get(this.rootUrl+'/api/PigmyCreations/GetPigmycreation/'+itemsPerPage+"/"+pageNo, this.httpOptions);
  
  }

SearchPigmyCreation(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  debugger;
  return this.http.get(this.rootUrl + '/api/PigmyCreations/Search/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}

SearchCustomerCreation(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number,branch) {
  debugger;
  return this.http.get(this.rootUrl + '/api/CustomerCreation/Search/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/"+branch +"/",this.httpOptions);
}


//Pigmy monthly Transfer

getSchemeForMonthlyTransfer(BRANCH_ID:any)
{
 return this.http.get(this.rootUrl + '/api/PigmyMonthlyTransfer/GetSchemeDropDown/'+ BRANCH_ID, this.httpOptions);
}

//accountType
getAllAccountTypes()
{
 return this.http.get(this.rootUrl + '/api/PigmyMonthlyTransfer/GetAccountTypeDropDown/', this.httpOptions);
}

getAgentCollectionDetailsGrid(c:any)
{
 //return this.http.get(this.rootUrl + '/api/PigmyMonthlyTransfer/GetAgentCollectionDetailsGrid/'+ agentId + '/'+ transDate+ '/'+ collectionDate + '/'+ OPtremittance , this.httpOptions);
 return this.http.post(this.rootUrl + '/api/PigmyMonthlyTransfer/GetAgentCollectionDetailsGrid', c , this.httpOptions);
}


getDailyCollectionDetailsGrid(agentId:any,transDate:any)
{
 return this.http.get(this.rootUrl + '/api/PigmyMonthlyTransfer/GetDailycollectionDetailsGrid/'+ agentId + '/'+ transDate, this.httpOptions);
}



// updateCustomerDetails(udm) {
//   debugger;
//   return this.http.put(this.rootUrl + '/api/CustomerCreation/UpdateCustomerDetails', udm, this.httpOptions);
// }


getDepositCommsission(){
  return this.http.get(this.rootUrl + '/api/PigmyMonthlyTransfer/GetDepositCommsission',this.httpOptions);
}


SavePigmyDetails(udm) {
  return this.http.post(this.rootUrl + '/api/PigmyMonthlyTransfer/SavePigmyDetails',udm, this.httpOptions);
 }


 pigmyimppath()
 {
   debugger;
   return this.http.get(this.rootUrl+'/api/PigmyImport/PathSelect',this.httpOptions);
 }
 pigmybackuppath()
 {
   return this.http.get(this.rootUrl+'/api/PigmyImport/BackUpPathSelect',this.httpOptions);
 }
  
  selectagent()
  {
    return this.http.get(this.rootUrl+'/api/PigmyImport/AgentSelect',this.httpOptions);
  }

   importpigmydata(agent_id:number)
   {
     return this.http.get(this.rootUrl+'/api/PigmyImport/PigmyImport/'+agent_id,this.httpOptions);
   }

   uploadImages(data)
   {
     debugger;
    return this.http.post(this.rootUrl +'/api/PigmyImport/uploaddata', data); 
   }

   pigmyexport(agnt:number)
   {
     debugger;
     return this.http.get(this.rootUrl+'/api/PigmyImport/Export/'+agnt,this.httpOptions);
   }
   VerifyMobileNo(Mob_No: any) {
  
    return this.http.put(this.rootUrl + '/api/Users/VerifyMobileNo/' + Mob_No + "/", this.httpOptions);
  }
  registerCustomers(register: Register) {

    return this.http.post(this.rootUrl + '/api/Account/Register', register, this.httpOptions);
  }

  GetAllStates() {
    return this.http.get(this.rootUrl + '/api/Users/GetAllStates', this.httpOptions);
  }

  GetAllDistrictById(ID: any) {
    return this.http.get(this.rootUrl + '/api/Users/GetAllDistrictById/' + ID, this.httpOptions);
  }

  ExitCUstId(CUSTID) { 
    return this.http.get(this.rootUrl + '/api/PigmyDetails/CheckServiceNoExist/' +CUSTID , this.httpOptions);
  
  }
  getfileexp()
   {
     debugger;
     window.open(this.rootUrl+'/api/PigmyImport/GetTestFile');
     //return this.http.get(this.rootUrl+'/api/PigmyImport/GetFileexp');
   }

   //Voucher Search

 getVoucherReceiptNo(Transtype:any,TransDate:any,branchId:any){
  return this.http.get(this.rootUrl + '/api/VoucherSearch/GetVoucherReceiptNo/'+ Transtype + '/'+ TransDate + '/'+branchId,this.httpOptions);
}

getReceiptNoDropdown(TransDate:any,Transtype:any,branchId:any){
  return this.http.get(this.rootUrl + '/api/VoucherSearch/GetReceiptNoDropdown/'+ TransDate + '/'+ Transtype + '/'+branchId,this.httpOptions);
}

getVoucherGrid(scr_no_num,BRANCH_ID){
  return this.http.get(this.rootUrl + '/api/VoucherSearch/GetVoucherGrid/'+ scr_no_num + '/'+ BRANCH_ID,this.httpOptions);
}

//Ledger dropdown
getLedgerDropdown(){
  return this.http.get(this.rootUrl + '/api/VoucherSearch/GetLedgerDropdown',this.httpOptions);
}


SaveVoucherDetails(udm) {
  return this.http.post(this.rootUrl + '/api/VoucherSearch/SaveVoucherDetails',udm, this.httpOptions);
 }

 deleteVoucherList(vsl){
  return this.http.post(this.rootUrl + '/api/VoucherSearch/DeleteVoucherList',vsl, this.httpOptions);
 }
 GetTalukbyId(DId: any) {
  return this.http.get(this.rootUrl + '/api/Users/GetTalukbyId/' + DId, this.httpOptions);
}
ResendOtp(Mob_No: any) {
  return this.http.put(this.rootUrl + '/api/Users/ResendOtp/' + Mob_No + "/", this.httpOptions);
}

//cc
getAllBloodgroups(){
  return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllBloodGroupsForDropdown',this.httpOptions);
}


getAllDetailsBasedOnArea(ACODE){
  return this.http.get(this.rootUrl + '/api/CustomerCreation/GetAllDetailsBasedOnArea/'+ ACODE,this.httpOptions);
}


//transaction report

Yearseting1(Branchid:number)
{
  debugger
 return this.http.get(this.rootUrl+'/api/ReportTransaction/findyear/' + Branchid,this.httpOptions);
}
ledgerlistget(modid:any)
{ 
  debugger;
 return this.http.get(this.rootUrl+'/api/ReportTransaction/Ledgerlist/'+modid,this.httpOptions);
}

ledgersublistget(modid:number,glsubid:number)
{
 return this.http.get(this.rootUrl+'/api/ReportTransaction/Ledgersublist/'+modid+'/'+glsubid,this.httpOptions);
}


reporttransaction(curryear:number,Eng:boolean,basicreport:Boolean,detailreport:Boolean,stmtreport:Boolean,dailycolreport:Boolean,BRANCH_ID:number,actype:number,L_Code:number,GLSUB_ID:number,cr_dr:number,transmode:number,AGENT_ID:number,acbranch:string,yrnd:string,ac_no:string,glsub:string,Name:string,fromdate:Date,todate:Date,chkledger:boolean)
{
  debugger;
 // console.log(formtrt);
  return this.http.get(this.rootUrl+'/api/ReportTransaction/TransactionReport/'+curryear+'/'+Eng+'/'+basicreport+'/'+detailreport+'/'+stmtreport+'/'+dailycolreport+'/'+BRANCH_ID+'/'+actype+'/'+L_Code+'/'+GLSUB_ID+'/'+cr_dr+'/'+transmode+'/'+AGENT_ID+'/'+acbranch+'/'+yrnd+'/'+ac_no+'/'+glsub+'/'+Name.trim()+'/'+fromdate+'/'+todate+'/'+chkledger,this.httpOptions);  
}

 custlist(BRANCH_ID:number,actype:number,GLSUB_ID:number,acc_no:string)
 {
   return this.http.get(this.rootUrl+'/api/ReportTransaction/CustList/'+BRANCH_ID+'/'+actype+'/'+GLSUB_ID+'/'+acc_no, this.httpOptions);
 }
 GetBranch()
   {
     return this.http.get(this.rootUrl+'/api/Users/Getbranch/',this.httpOptions);
   }

   
// reporttransaction1(Eng:boolean,kan:boolean,basicreport:Boolean,detailreport:Boolean,stmtreport:Boolean,dailycolreport:Boolean,BRANCH_ID:number,actype:number,L_Code:number,GLSUB_ID:number,cr_dr:number,transmode:number,AGENT_ID:number,acbranch:string,yrnd:string,ac_no:string,glsub:string,Name:string,fromdate:Date,todate:Date,pigmycollection:boolean,pigmysheet:boolean,pigmyreport1:string)
// {
//   debugger;
//  // console.log(formtrt);
//   return this.http.get(this.rootUrl+'/api/ReportTransaction/TransactionReport/'+Eng+'/'+kan+'/'+basicreport+'/'+detailreport+'/'+stmtreport+'/'+dailycolreport+'/'+BRANCH_ID+'/'+actype+'/'+L_Code+'/'+GLSUB_ID+'/'+cr_dr+'/'+transmode+'/'+AGENT_ID+'/'+acbranch+'/'+yrnd+'/'+ac_no+'/'+glsub+'/'+Name.trim()+'/'+fromdate+'/'+todate+'/'+pigmycollection+'/'+pigmyreport1+'/'+pigmysheet,this.httpOptions);  
// }


reporttransaction1(curryear:number,basicreport:boolean,detailreport:boolean,stmtreport:boolean,dailycolreport:boolean,loanrecreport:boolean,detailreport2:boolean,pigmysheetreport:boolean,loanondeposit:boolean,BRANCH_ID:number,actype:number,L_Code:number, GLSUB_ID:number,cr_dr:number,transmode:number,AGENT_ID:number,acbranch:string,yrnd:string,ac_no:string,glsub:string,Name:string,fromdate:Date,todate:Date,chkledger:boolean,pigmysheet:string,pigmycollection:string,pigmyreport1 :string,remdt:boolean,accountwisereport:boolean)
{
  debugger;
 // console.log(formtrt);
  return this.http.get(this.rootUrl+'/api/ReportTransaction/TransactionReport/'+curryear+'/'+basicreport+'/'+detailreport+'/'+stmtreport+'/'+dailycolreport+'/'+loanrecreport+'/'+detailreport2+'/'+pigmysheetreport+'/'+loanondeposit+'/'+BRANCH_ID+'/'+actype+'/'+L_Code+'/'+GLSUB_ID+'/'+cr_dr+'/'+transmode+'/'+AGENT_ID+'/'+acbranch+'/'+yrnd+'/'+ac_no+'/'+glsub+'/'+Name.trim()+'/'+fromdate+'/'+todate+'/'+chkledger+'/'+pigmysheet+'/'+pigmycollection+'/'+pigmyreport1+'/' +remdt+'/' +accountwisereport, this.httpOptions);  
}

printvoucherHere(scr_no:any,TransType:any,scr_no_num:any,BRANCH_ID:number)
{
  debugger;
 return this.http.get(this.rootUrl+'/api/VoucherSearch/PrintVoucherHere/'+scr_no+'/'+TransType+'/'+scr_no_num+'/'+BRANCH_ID, this.httpOptions);
}

getschemechit(module:any)
{
 debugger;
  return this.http.get(this.rootUrl+'/api/ChitReceipt/Scheme1/'+module,this.httpOptions);
}


chitcustlist(BRANCH_ID:number,actype:number,acscheme:number,acc_no:string)
 {
   debugger;
   return this.http.get(this.rootUrl+'/api/ChitReceipt/ChitCustList/'+BRANCH_ID+'/'+actype+'/'+acscheme+'/'+acc_no, this.httpOptions);
 }

 
 Reciptcredit(formrecipt:any)
 {
   debugger;  
   return this.http.post(this.rootUrl+'/api/ChitReceipt/ReciptCredit/',formrecipt,this.httpOptions);  
 }
 GetCustName(CUSTID) { 
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetCustName/' +CUSTID , this.httpOptions);

}

GetCustomerDetails1(SearchValue: any, SearchName: any) {
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetCustomerDetails/' + SearchValue + "/" + SearchName + "/", this.httpOptions);
}
GetAccNo1(CUSTID) { 
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetAccNo/' +CUSTID , this.httpOptions);
}
GetGenderName(CODE) { 
  debugger;
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetGenderName/' +CODE , this.httpOptions);

}
GetRelationName() { 
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetRelationName', this.httpOptions);

}

GetSchemeName() { 
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetScheme', this.httpOptions);

}
GetNoOfMemb(CHITSCHEME_NO) { 
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetNoOfMemName/' +CHITSCHEME_NO , this.httpOptions);

}

GetSchemeAmt(CHITSCHEME_NO) { 
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetSchemeAmt/' +CHITSCHEME_NO , this.httpOptions);

}
GetRegFee(CHITSCHEME_NO) { 
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetRegFee/' +CHITSCHEME_NO , this.httpOptions);

}
GetInstAmt(CHITSCHEME_NO) { 
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetInstAmt/' +CHITSCHEME_NO , this.httpOptions);

}

GetChitDate(CHITSCHEME_NO) { 
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetChitDate/' +CHITSCHEME_NO , this.httpOptions);

}

GetToknNo(CHITSCHEME_NO) { 
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetToknNo/' +CHITSCHEME_NO , this.httpOptions);

}
GetAccountNo(CHITSCHEME_NO,BRANCH_ID) { 
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetAccNo1/' +CHITSCHEME_NO  + "/" +BRANCH_ID, this.httpOptions);

}


GetSubLedger1(MODID,BRANCH_ID) { 
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetSubLedger/' +MODID  + "/" +BRANCH_ID, this.httpOptions);

}
PostChitCreation(udm) {
  return this.http.post(this.rootUrl + '/api/ChitMemberCreationDetails/CreateChitCreation', udm, this.httpOptions);
}
GetChitCreationDetails(CHITSCHEME_NO) {
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetChitCreation/' +CHITSCHEME_NO, this.httpOptions);

}
SearchChitCreation(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number,scheme:number) {
  debugger;
  return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/Search/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/"+scheme,this.httpOptions);
}
GetAllBranchs() { 
  debugger;
 return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetBranch', this.httpOptions);

}
GetAllAC() { 
  debugger;
 return this.http.get(this.rootUrl + '/api/ChitMemberCreationDetails/GetAC', this.httpOptions);

}

GetDividendLedger()
{ 
   return this.http.get(this.rootUrl +'/api/ChitFound/GetDividendLedger',this.httpOptions);
}

GetChitRegis()
{
   return this.http.get(this.rootUrl +'/api/ChitFound/ChitRegistionDetails',this.httpOptions);
}


SocietyContribution()
{
   return this.http.get(this.rootUrl +'/api/ChitFound/ChitComDetails',this.httpOptions);
}

ChitFundPenality()
{
   return this.http.get(this.rootUrl +'/api/ChitFound/ChitFundPenality',this.httpOptions);
}

ChitAccount()
{
   return this.http.get(this.rootUrl +'/api/ChitFound/ChitAccount',this.httpOptions);
}

GetChitAccount()
{
   return this.http.get(this.rootUrl +'/api/ChitFound/GetChitDetails',this.httpOptions);
}

GetallChitlist()
{
   return this.http.get(this.rootUrl +'/api/ChitFound/GetChitDetails',this.httpOptions);
}

PostChitForm(data:any) 
{    
     return this.http.post(this.rootUrl + '/api/ChitFound/CreateChit',data, this.httpOptions);
}

ChitClaim()
{
   
   return this.http.get(this.rootUrl +'/api/ChitClaim/GetClaimNo',this.httpOptions);
}

GetChitScheme()
{
   
   return this.http.get(this.rootUrl +'/api/ChitClaim/GetSchemDetails',this.httpOptions);
}

GetSurity()
{
   
   return this.http.get(this.rootUrl +'/api/ChitClaim/GetSurityDetails',this.httpOptions);
}

CategoryDetails(GRP_ABB:any)
{
  debugger
  return this.http.get(this.rootUrl+'/api/ChitClaim/GetSubBranchByID/' + GRP_ABB,this.httpOptions)
}

BidDetails(GRP_ABB:any)
{
  debugger
  return this.http.get(this.rootUrl+'/api/ChitClaim/GetBidDetails/' + GRP_ABB,this.httpOptions)
}


CollectedAmountDetails(GRP_ABB:any)
{
  debugger
  return this.http.get(this.rootUrl+'/api/ChitClaim/GetColectedAmmount/' + GRP_ABB,this.httpOptions)
}


AccountDetails(GRP_ABB:any,modid:any,branch:number)
{
  debugger
  return this.http.get(this.rootUrl+'/api/ChitClaim/GetSubBranch/' + GRP_ABB+'/'+modid+'/'+branch,this.httpOptions)
}


CustomerDetails(GRP_ABB:number,GLSUB_ID:any)
{
  debugger
  return this.http.get(this.rootUrl+'/api/ChitClaim/CustomerDetails/' + GRP_ABB +'/'+ GLSUB_ID + '/',this.httpOptions)
}

GetCustomerBLC(GRP_ABB:number,GLSUB_ID:any)
{
  debugger
  return this.http.get(this.rootUrl+'/api/ChitClaim/GetCustomerBlc/' + GRP_ABB +'/'+ GLSUB_ID + '/',this.httpOptions)
}

MonthDetails(GRP_ABB:any)
{
  debugger
  return this.http.get(this.rootUrl+'/api/ChitClaim/GetMonth_No/' + GRP_ABB,this.httpOptions)
}
SaveClaim(data:any) 
{
  debugger
   return this.http.post(this.rootUrl + '/api/ChitClaim/SaveClaimDetails',data, this.httpOptions);
}

//GL-TRANSACTION

 Yearseting(Branchid:number)
 {
   debugger
  return this.http.get(this.rootUrl+'/api/gltransaction/findyear/' + Branchid,this.httpOptions);
 }

 GetAllLedgerName1(MODID)
{  
  debugger;
   return this.http.get(this.rootUrl +'/api/gltransaction/GetAllLedgerName/'+MODID,this.httpOptions);
}
GetAccountType()
{  
   return this.http.get(this.rootUrl +'/api/gltransaction/GetAllAccountType',this.httpOptions);
}

GetSubLedger3(LCode){
  return this.http.post(this.rootUrl + '/api/gltransaction/GetSubLedgerCode/'+LCode,null ,this.httpOptions);
 }
//  gltransreport(curryear:number,languagedet:string,chkledger:boolean,seloptio:string,sumdet:string,selbranch:number,frmdate:Date,todate:Date,logbranch:number)
//   {
//     debugger;
//     return this.http.get(this.rootUrl+'/api/gltransaction/GlTransreport/'+curryear+'/'+languagedet+'/'+chkledger+'/'+ seloptio+'/'+sumdet+'/'+selbranch+'/'+frmdate+'/'+todate+'/'+logbranch,this.httpOptions)
//   }

gltransreport(curryear:number,chkledger:boolean,seloptio:string,sumdet:string,selbranch:number,frmdate:Date,todate:Date,logbranch:number,actype:number,acledger:number,Sbledger:number)
{
  debugger;
  return this.http.get(this.rootUrl+'/api/gltransaction/GlTransreport/'+curryear+'/'+chkledger+'/'+ seloptio+'/'+sumdet+'/'+selbranch+'/'+frmdate+'/'+todate+'/'+logbranch+'/'+actype+'/'+acledger+'/'+Sbledger,this.httpOptions)
}

//Chit Member Transfer

      //ChitSchemedropdown
      getChitSchemeCodeForDropdown(){
        return this.http.get(this.rootUrl + '/api/ChitMemberTransferController/GetChitSchemeCodeForDropdown',this.httpOptions);
      }
            //ChitDetails 
      getChitDetails(SCHID){
        return this.http.get(this.rootUrl + '/api/ChitMemberTransferController/GetChitDetails/'+ SCHID,this.httpOptions);
      }
              //token no. based
      getDetailsBasedOnTokenNo(TokenNo,SCHID){
        return this.http.get(this.rootUrl + '/api/ChitMemberTransferController/GetDetailsBasedOnTokenNo/'+ TokenNo + '/' + SCHID,this.httpOptions);
      }      
              //CustId based
      getDetailsBasedOnCustId(CUSTID,SCHID){
        return this.http.get(this.rootUrl + '/api/ChitMemberTransferController/GetDetailsBasedOnCustId/'+ CUSTID + '/' + SCHID,this.httpOptions);
      }
      
        //CustIdsdropdown
        getAllCUSTIdsForDropdown(){
        return this.http.get(this.rootUrl + '/api/ChitMemberTransferController/GetAllCUSTIdsForDropdown',this.httpOptions);
      }
      


  //universal
  getallaccountunivers(aacc_no:string,aglsub_id:string,branch_id:number)
  {
    return this.http.get(this.rootUrl+'/api/Universal/GetAllAccount/'+ aacc_no+'/'+aglsub_id+'/'+branch_id,this.httpOptions);
  }
    //universal
    getallaccountuniversreport(aacc_no:string,aglsub_id:string,branch_id:number)
    {
      return this.http.get(this.rootUrl+'/api/Universal/GetAllAccountreport/'+ aacc_no+'/'+aglsub_id+'/'+branch_id,this.httpOptions);
    }
  ///chitcreation
  



//sbcal_intrest
loadscheme(branch:number)
{
  debugger;
  return this.http.get(this.rootUrl+'/api/SB_Int_cal/Getschemefrsbint/'+ branch,this.httpOptions);
}

sbintolddata(frmac_no:number,toac_no:number)
{
  return this.http.get(this.rootUrl+'/api/SB_Int_cal/Getsbint_old/'+ frmac_no+'/'+toac_no,this.httpOptions);
}

sbintnewdata(frmdt:any,todt:any,minbal:number,minint:number,branchsel:number,schem:number,trnsdt:any,accfrm:number,accto:number,intrat:number,stafrat:number,accno:string,accname:string,typeofdura:string)
{
  return this.http.get(this.rootUrl+'/api/SB_Int_cal/Getsbint_new/'+frmdt+'/'+todt+'/'+minbal+'/'+minint+'/'+branchsel+'/'+schem+'/'+trnsdt+'/'+accfrm+'/'+accto+'/'+intrat+'/'+stafrat+'/'+accno+'/'+accname+'/'+typeofdura,this.httpOptions);
}


getMaturityDateForPigmyCreation(Open_DT:any,period:any)
{
  return this.http.get(this.rootUrl+'/api/PigmyCreations/GetMaturityDateForPigmyCreation/'+Open_DT+"/"+period, this.httpOptions);
}

//Pigmy monthly transfer
transfermonthly(pigmmonth) {
  debugger;
 return this.http.post(this.rootUrl + '/api/PigmyMonthlyTransfer/Transfermonthly',pigmmonth, this.httpOptions);
}

getservicemod(frmname:string,tag:string)
{
  return this.http.get(this.rootUrl+'/api/Universal/Getmodpvt/'+frmname+'/'+tag,this.httpOptions);
}


//PARTPAYMENT

fetchpigmyaxno(acno:string,glsbid:number,brnchid:number,me:string)
{
 debugger;
  return this.http.get(this.rootUrl+'/api/Pigmy/GetPigmyDetails/'+acno+'/'+glsbid+'/'+brnchid+'/'+me,this.httpOptions);
}
GetCompany()
{
  return this.http.get(this.rootUrl + '/api/Universal/GetCompany', this.httpOptions);
}
chckacc(notaccno,subid,branch_id,me)
{
  debugger;
  return this.http.get(this.rootUrl + '/api/Pigmy/checkacc/'+notaccno+'/'+subid+'/'+branch_id+'/'+me, this.httpOptions);
}
agreemntdocupload(data){ 
  debugger;   
  return this.http.post(this.rootUrl+"/api/PigmyDetails/Agreementdoc",data);
 }
 getAllAreas1() {
  return this.http.get(this.rootUrl + '/api/Offices/GetAllAreas', this.httpOptions);
 }
 
 getAllTaluks1() {
  return this.http.get(this.rootUrl + '/api/Offices/GetAllTaluks', this.httpOptions);
 }

 getAllDistricts1() {
  return this.http.get(this.rootUrl + '/api/Offices/GetAllDistricts', this.httpOptions);
 }
 

 getAllStates1() {
  return this.http.get(this.rootUrl + '/api/Offices/GetAllStates', this.httpOptions);
 }
 
 getAllDetailsBasedOnArea1(ACODE){
  return this.http.get(this.rootUrl + '/api/Offices/GetAllDetailsBasedOnArea/'+ ACODE,this.httpOptions);
}

uploadProfDoccus(data){ 
  debugger;   
  return this.http.post(this.rootUrl+"/api/CustomerCreation/Profdoc",data);
 }

 getconstitutiontype(type)
 {
   debugger;
  return this.http.get(this.rootUrl+"/api/CustomerCreation/ConstitutionType/"+type, this.httpOptions);
 }

 getpigmylcode(logbranch)
 {
   debugger;
  return this.http.get(this.rootUrl+"/api/Pigmy/getpigmydetails/"+logbranch, this.httpOptions);
 }

 GetBranchName(branch_id)
 {
   return this.http.get(this.rootUrl + '/api/Universal/GetBranchName/'+branch_id, this.httpOptions);
 }

 GetDesignation()
 {
  return this.http.get(this.rootUrl+"/api/CustomerCreation/getdesignation", this.httpOptions);
 }
 getmemberdetails(custid)
 {
  return this.http.get(this.rootUrl+"/api/CustomerCreation/getdesignation", this.httpOptions);
 }


 
//scheme creation

GetAccountTypeforschemecreation()
{  
  debugger;
   return this.http.get(this.rootUrl +'/api/schemecreation/GetAllAccountType',this.httpOptions);
}

GetAllLedgerNameforsc(ACC_TYPE)
{  
  debugger;
   return this.http.get(this.rootUrl +'/api/schemecreation/GetAllLedgerName/'+ACC_TYPE,this.httpOptions);
}


GetAllBranchesforsc()
{  
  debugger;
   return this.http.get(this.rootUrl +'/api/schemecreation/GetAllBranches',this.httpOptions);
}

PostSchemeCreation(udm) {
  debugger;
  return this.http.post(this.rootUrl + '/api/schemecreation/GetSaveSchemeCreation', udm, this.httpOptions);
}


GetSchemeDetails(itemsPerPage:any,pageNo:any,branch_id) {

  debugger;
  return this.http.get(this.rootUrl + '/api/schemecreation/GetAllScheme/'+itemsPerPage+"/"+pageNo+"/"+branch_id, this.httpOptions);

}

SearchScheme(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  debugger;
  return this.http.get(this.rootUrl + '/api/schemecreation/Search/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}
DeleteScheme(GLSUB_ID) {
  debugger;
  return this.http.delete(this.rootUrl + '/api/schemecreation/DeleteScheme/' + GLSUB_ID, this.httpOptions);
}
GetSchemeById(GLSUB_ID,branch)  {
  debugger;
   return this.http.get(this.rootUrl + '/api/schemecreation/GetByIdScheme/' +GLSUB_ID+'/'+branch , this.httpOptions);
 }
 updatescheme(udm) 
 {
   debugger;
   return this.http.post(this.rootUrl + '/api/schemecreation/updateSchemeCreation', udm, this.httpOptions);
 }
 getmastercompany()
 {
  debugger;
  return this.http.get(this.rootUrl + '/api/Universal/GetMasterCompany',this.httpOptions);
 }
 getstatecountry(code)
 {
  return this.http.get(this.rootUrl + '/api/Offices/GetStateCountry/'+code,this.httpOptions);
 }
 GetAllbranch(comp_id)
 {
  return this.http.get(this.rootUrl + '/api/Users/Getbranchuser/'+comp_id,this.httpOptions);
 }
}

 


// WEBPACK FOOTER //
// ./src/app/shared/user.service.ts